// @ts-nocheck
/* eslint-disable */
export const appChevronRight12Icon = {
    data: `<svg viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 9.5L7.09375 6.125L4 2.75" stroke="currentColor" stroke-width="1.125"/></svg>`,
    name: 'chevron-right-12' as const
};